import styled from 'styled-components';
import {
  getTextType,
  getSpace,
  backgroundClipPath,
  mq
} from '../../../../../../../stylesheets/tools';

const StyledDateLine = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${getSpace('m')};
  margin-bottom: ${getSpace('s')};

  ${mq('m')} {
    margin-top: ${getSpace('l')};
    margin-bottom: ${getSpace('m')};
  }

  .dateLine__date {
    position: relative;
    ${getTextType('secondary')};
    ${backgroundClipPath('#000', '6px')};
    border-radius: 3px;
    height: 32px;
    min-width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    padding: 10px;

    ${mq('m')} {
      font-size: 30px;
      height: 55px;
      min-width: 55px;
      padding: ${getSpace('xxs')};
      ${backgroundClipPath('#000', '15px')};
    }
  }

  .dateLine__date::after {
    content: '';
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    position: absolute;
    top: 3px;
    left: 3px;
    z-index: -1;
    ${backgroundClipPath('#fff', '6px')};
    border-radius: 3px;

    ${mq('m')} {
      ${backgroundClipPath('#fff', '15px')};
    }
  }

  .dateLine__line {
    padding: 4px ${getSpace('xxs')};
    width: 100%;
    background: ${props => props.theme.siteTheme.primary};
    clip-path: polygon(
      0% 0%,
      calc(100% - 6px) 0%,
      100% 6px,
      100% 100%,
      100% 100%,
      0% 100%,
      0% 100%,
      0% 0%
    );

    ${mq('m')} {
      padding: ${getSpace('xxs')};
      clip-path: polygon(
        0% 0%,
        calc(100% - 15px) 0%,
        100% 15px,
        100% 100%,
        100% 100%,
        0% 100%,
        0% 100%,
        0% 0%
      );
    }

    span {
      text-transform: unset;
      color: white;
    }
  }
`;

export default StyledDateLine;
